import React from 'react';

import { calculateWidth } from '../../tools';
import { Typography } from '../../../../material-ui/Typography';
import { useStyles } from '../../useStyles';

const SectionTitle = ({ length, title }) => {
    const classes = useStyles();

    return (
        <Typography
            className={classes.subtitle}
            style={{
                flexBasis: calculateWidth(length),
                fontWeight: 600,
            }}
        >
            {title}
        </Typography>
    );
};
const SectionTitleMemoized = React.memo(SectionTitle);
export { SectionTitleMemoized as SectionTitle };
